import React from 'react';

type Props = {
  light?: boolean;
  style?: React.CSSProperties;
};

const OnLiveTag: React.FC<Props> = ({ light, style = {} }) => (
  <div
    className={`${
      light ? 'bg-base-lighter-24' : 'bg-base-dark'
    } flex items-center font-subtitle4 text-white rounded-5 h-24 px-8`}
    style={style}
  >
    <div className="w-8 h-8 rounded-full bg-red-main inline-block flex-shrink-0 mr-8" />
    En vivo
  </div>
);

export default OnLiveTag;
